/**
 * @license
 * Copyright (c) Peculiar Ventures, LLC.
 *
 * This source code is licensed under the BSD 3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { FunctionalComponent, h } from '@stencil/core';
import { JSXBase } from '@stencil/core/internal';

export const FortifyLogoFull: FunctionalComponent<JSXBase.SVGAttributes<SVGElement>> = (props) => (
  <svg
    {...props}
    width="72"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2707_2181)">
      <path fill="url(#paint0_linear_2707_2181)" d="M7.306 13.726s.376-3.735.407-4.362c-.494-.27-.83-.8-.83-1.408 0-.884.708-1.6 1.582-1.6.874 0 1.582.716 1.582 1.6 0 .61-.338 1.142-.834 1.41.031.622.41 4.36.41 4.36H7.307Zm7.75-10.954-.159-.002-.096-.002A9.227 9.227 0 0 1 8.465 0 9.215 9.215 0 0 1 .978 2.728l-.046.001v4.617c0 5.168 2.988 9.63 7.312 11.711l.106.051a.29.29 0 0 0 .225 0c4.384-2.058 7.423-6.55 7.423-11.762V2.732l-.063-.001a9.094 9.094 0 0 1-.879.042v-.001Z" />
      <path
        stroke="url(#paint1_linear_2707_2181)" stroke-width=".5"
        d="M7.55 9.454a1.763 1.763 0 0 1-.824-1.498c0-.972.778-1.76 1.739-1.76.96 0 1.738.788 1.738 1.76 0 .62-.32 1.183-.828 1.5a105.67 105.67 0 0 0 .198 2.174c.044.464.093.953.141 1.437l.048.465.018.176.017.176H7.132l.018-.176.018-.176.046-.464.14-1.435.015-.15c.095-.996.16-1.713.182-2.032l-.001.003ZM.979 2.889v-.002h.003-.003v.002Zm.11.01v4.448c0 4.99 2.847 9.461 7.222 11.567l.095.046a.152.152 0 0 0 .104.005c4.434-2.082 7.33-6.584 7.33-11.618V2.899a9.294 9.294 0 0 1-.784.033l-.12-.001h-.04l-.05-.001-.05-.002A9.376 9.376 0 0 1 8.466.223a9.362 9.362 0 0 1-6.592 2.71c-.075 0-.152 0-.232-.004a9.823 9.823 0 0 1-.553-.03Z" clip-rule="evenodd"
      />
    </g>
    <path fill="var(--pv-color-black)" d="M29.97 3.487v1.375c-1.428-.12-2.141.478-2.141 1.853v.24h2.14v1.314h-2.14v6.695H26.46V8.27h-1.308V6.954h1.308v-.239c0-1.076.297-1.913.892-2.45.595-.598 1.487-.837 2.616-.778ZM38.235 7.97c-.832-.836-1.843-1.255-2.973-1.255s-2.2.419-2.973 1.255c-.833.837-1.249 1.853-1.249 2.99 0 1.135.416 2.21 1.249 2.988.832.837 1.843 1.255 2.973 1.255s2.2-.418 2.973-1.255c.833-.837 1.25-1.853 1.25-2.989 0-1.195-.417-2.152-1.25-2.989Zm-1.01 5.081a2.824 2.824 0 0 1-2.022.837 2.854 2.854 0 0 1-2.854-2.87c0-.836.297-1.493.832-2.031a2.726 2.726 0 0 1 2.022-.837 2.854 2.854 0 0 1 2.854 2.87c0 .776-.297 1.434-.833 2.031ZM42.992 6.954V8.27c.476-1.016 1.308-1.494 2.498-1.494v1.494c-.714-.06-1.249.18-1.784.538-.476.419-.714 1.016-.714 1.913v4.304h-1.367v-8.07h1.367ZM52.031 6.954V8.27h-2.14v4.364c0 .418.059.658.237.837.178.18.416.239.714.239h1.189v1.255c-1.249.18-2.14.06-2.676-.299-.535-.358-.832-1.016-.832-2.032V8.269h-1.606V6.954h1.605V5.101l1.368-.418v2.271h2.141ZM54.648 5.46c-.298 0-.476-.12-.654-.3-.179-.178-.298-.418-.298-.657 0-.239.12-.478.298-.657.178-.18.416-.3.654-.3.238 0 .475.12.654.3.178.18.297.418.297.657 0 .24-.119.479-.297.658-.178.239-.357.299-.654.299ZM55.36 6.954h-1.367v8.07h1.368v-8.07ZM61.962 3.487v1.375c-1.428-.12-2.141.478-2.141 1.853v.24h2.14v1.314h-2.14v6.695h-1.368V8.27h-1.308V6.954h1.308v-.239c0-1.076.298-1.913.892-2.45.654-.598 1.546-.838 2.617-.778ZM67.373 13.29l2.319-6.336h1.487l-3.27 8.548c-.358.897-.833 1.614-1.428 2.092a2.97 2.97 0 0 1-2.14.658v-1.315c1.01.06 1.724-.479 2.14-1.674l.119-.299-3.45-8.01h1.488l2.735 6.336Z" />
    <defs>
      <linearGradient
        id="paint0_linear_2707_2181" x1="8.465"
        x2="8.465" y1="0"
        y2="19.13" gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4DA3FC" />
        <stop offset="1" stop-color="#027EFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2707_2181" x1="8.41"
        x2="8.41" y1="18.972"
        y2=".223" gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#49A1FC" />
        <stop offset="1" stop-color="#0680FF" />
      </linearGradient>
      <clipPath id="clip0_2707_2181">
        <path fill="#fff" d="M.932 0h15.066v19.13H.932z" />
      </clipPath>
    </defs>
  </svg>
);
